import Users from './users';
import UserView from './user_view';
import UserEdit from './user_edit';
import UserAdd from './user_add';
import UserProfile from './user_profile';

export {
  Users,
  UserView,
  UserEdit,
  UserAdd,
  UserProfile,
};
